import { useEffect, useMemo } from 'react';

import { useTableFiltersStore } from '../store';

export default function useTableFilters(filters, key) {
  // Memoize the initial state so that it only recalculates when `filters` change.
  const initialState = useMemo(() => {
    const state = {};
    filters.forEach((filter) => {
      if (!filter.options) {
        state[filter.title] = [];
      } else {
        state[filter.title] = filter.options
          .filter((option) => option.selected)
          .map((option) => option.value);
      }
    });
    return state;
  }, [filters]);

  // Get the current filter state for this key, or fall back to initialState.
  const filtersState =
    useTableFiltersStore((state) => state.filtersStates[key]) || initialState;
  const setFiltersStates = useTableFiltersStore(
    (state) => state.setFiltersStates
  );

  // Initialize the state in the store only once if not already set.
  useEffect(() => {
    if (!useTableFiltersStore.getState().filtersStates[key]) {
      setFiltersStates(key, initialState);
    }
  }, [key, initialState, setFiltersStates]);

  // Handler to toggle a filter option.
  const updateFiltersState = (filterTitle, optionValue) => {
    const currentFiltersState =
      useTableFiltersStore.getState().filtersStates[key] || initialState;
    const selectedValues = currentFiltersState[filterTitle] || [];
    const isSelected = selectedValues.includes(optionValue);

    const newFiltersState = {
      ...currentFiltersState,
      [filterTitle]: isSelected
        ? selectedValues.filter((value) => value !== optionValue)
        : [...selectedValues, optionValue],
    };

    setFiltersStates(key, newFiltersState);
  };

  return { filtersState, updateFiltersState };
}
